import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/news.json";
import tags from "@/.sourceflow/news_tag.json";

export const useNews = ({ locale, filters = null, limit = 8 } = {}) => {
  let collection = useSourceFlowCollection(data).filter(function(item) {
    return item.country == (locale == "/us/" ? "United States" : "United Kingdom") || item.country == "All";
  });

  if (filters && filters.length > 0) {
    let filterTags = tags?.category_values?.filter((tag) => tag.id.includes(filters)).map((tag) => tag.title.en);
    collection = collection.filter(function(article) {
      return Array.isArray(article?.tag) ? article?.tag.some((filter) => filter?.includes(filterTags)) : null;
    });
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useNews;
